// Anzeige findet mittels Google Docs statt
// Ich musste hierzu die DocID eingeben und ein AppScript erstellen, dass den HTML Export macht

import { useEffect, useState, useRef } from "react";
import DOMPurify from "dompurify";

export default function Rules() {
    const [html, setHtml] = useState("");
    const [err, setErr] = useState(null);
    const [loading, setLoading] = useState(true);
    const contentRef = useRef(null);

    // === Deine IDs/URLs ===
    const DOC_ID  = "1LYBGDxeZfWfW22j48THJKAMXMre-uqSCISnQ0nphE9o";
    const GAS_URL = "https://script.google.com/macros/s/AKfycbwN30DxZBPqTBdyi5KvQ1r4YrZRlpgYWh-hr5Z5CrFjipxLD6ohHpsu8N0PP28_9Dq-/exec";
    const SECRET  = "Dasistmeinganzlangersecretundgehoertnurmirsondernsolleinfachlangsein";

    useEffect(() => {
        (async () => {
            try {
                const url = `${GAS_URL}?docId=${encodeURIComponent(DOC_ID)}&token=${encodeURIComponent(SECRET)}&t=${Date.now()}`;
                const res = await fetch(url, { headers: { Accept: "application/json" } });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const data = await res.json();
                if (!data.ok || !data.html) throw new Error(data.error || "Leere Antwort");

                // <html>/<body> abschneiden (falls vorhanden)
                const raw = data.html
                    .replace(/<!DOCTYPE[\s\S]*?<body[^>]*>/i, "")
                    .replace(/<\/body>\s*<\/html>\s*$/i, "");

                setHtml(DOMPurify.sanitize(raw, { USE_PROFILES: { html: true } }));
            } catch (e) {
                setErr(e.message);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    useEffect(() => {
        if (!html || !contentRef.current) return;
        const root = contentRef.current;

        const textRe = /^(\d+(?:\.\d+){1,4})\s+/; // z.B. 2.1 / 2.1.1 / 2.1.1.1
        const headingRe = /^\s*(\d+(?:\.\d+){0,3})\.?\s*/; // 1 / 2. / 3.1 / 9.2.1

        // ---- eigentliche Transform-Funktion ----
        const applyTransforms = () => {
            if (!root) return;

            root.querySelectorAll("p, div, li").forEach(el => {
                const txt = (el.textContent || "").trim();
                const m = txt.match(textRe);
                if (!m) return;

                const label = m[1];
                // +1, damit 2.1 -> depth-1, 2.1.1 -> depth-2, usw.
                const depth = Math.min(label.split(".").length, 4);

                // robustes Wrappen (auch wenn <strong> oder <b> enthalten sind)
                let didWrap = false;
                const htmlReLoose = /^(?:\s*(?:<(?:strong|b|span)[^>]*>))*\s*(\d+(?:\.\d+){1,4})\s+/i;
                if (htmlReLoose.test(el.innerHTML)) {
                    el.innerHTML = el.innerHTML.replace(htmlReLoose, (m, num) =>
                        m.replace(num, `<span class="rv-num">${num}</span>`)
                    );
                    didWrap = true;
                }
                if (!didWrap) {
                    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
                    const firstText = walker.nextNode();
                    if (firstText) {
                        const t = firstText.nodeValue || "";
                        const m2 = t.match(/^(\s*)(\d+(?:\.\d+){1,4})(\s+)([\s\S]*)/);
                        if (m2) {
                            const [, lead, num, space, rest] = m2;
                            const spanNum = document.createElement("span");
                            spanNum.className = "rv-num";
                            spanNum.textContent = num;
                            const frag = document.createDocumentFragment();
                            if (lead) frag.appendChild(document.createTextNode(lead));
                            frag.appendChild(spanNum);
                            frag.appendChild(document.createTextNode(space + rest));
                            firstText.parentNode.replaceChild(frag, firstText);
                        }
                    }
                }

                el.classList.add("rv-rule");
                el.classList.add(`rv-depth-${depth}`);
            });

            // Kapitel-Überschriften (1, 2, 3.1 …)
            root.querySelectorAll("h1, h2, h3, h4").forEach((h) => {
                if (h.dataset.rvHeadingProcessed === "1") return;

                const raw = (h.textContent || "").trim();
                const m = raw.match(headingRe);
                if (!m) return;

                const depth = Math.min(m[1].split(".").length, 4);
                h.classList.add("rv-heading");
                h.classList.add(`rv-depth-${depth}`);
                h.dataset.rvHeadingProcessed = "1";
            });
        };

        // direkt nach dem ersten Render ausführen
        applyTransforms();

        // --- Re-Apply bei Hash-Änderungen (Klick im Inhaltsverzeichnis) ---
        const onHashChange = () => {
            // kleiner Timeout, damit der Browser erst gescrollt hat
            setTimeout(applyTransforms, 0);
        };

        window.addEventListener("hashchange", onHashChange);

        // --- Klicks innerhalb des Regelwerks (z.B. TOC-Links) ---
        const onInternalClick = (e) => {
            const a = e.target.closest("a[href^='#']");
            if (!a) return;
            // nach dem Scrollen noch einmal sicherstellen, dass alle Klassen sitzen
            setTimeout(applyTransforms, 0);
        };

        root.addEventListener("click", onInternalClick);

        return () => {
            window.removeEventListener("hashchange", onHashChange);
            root.removeEventListener("click", onInternalClick);
        };
    }, [html]);


    if (loading) return <div className="page rules"><div className="card">Lade Regelwerk…</div></div>;
    if (err)     return <div className="page rules"><div className="card error">Fehler: {err}</div></div>;

    return (

        <div className="card card--accent">
            <h1>REGELWERK</h1>
            <p>Das ist das Regelwerk der GT3 Xperience Serie</p>

        <div className="page rules">
            <div className="card rules-card">
                <h1 className="rules-title">Regelwerk</h1>
                <div
                    ref={contentRef}
                    className="rules-content"
                    dangerouslySetInnerHTML={{ __html: html }}
                />
            </div>
        </div>
        </div>
    );
}